import {Injectable} from '@angular/core';
import {PageService} from './state/service';
import {PageQuery} from './state/query';
import {FilterService as BaseService} from '../../components/filter.service';
import {Page} from './state/model';
import {PageState, Store} from './state/store';


@Injectable({providedIn: 'root'})
export class FilterService extends BaseService<Page, PageState, PageQuery, Store> {
  constructor(protected query: PageQuery, protected api: PageService) {
    super(query, api);
  }
}
